var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[(_vm.title)?_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('v-card-text',[(_vm.preformatted)?_c('pre',[_vm._v(_vm._s(_vm.text))]):_c('div',[_c('span',{staticClass:"{ italic: italic }"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }